<div
  class="card ribbone-card shadow-none flex-fill h-100"
  data-aos="flip-left"
  data-aos-duration="1000"
  data-aos-once="true"
>
  <!-- Recommended Ribbon -->
  <div *ngIf="isCurrentPlan" class="arrow-ribbone-left bg-secondary">Current Plan</div>

  <div class="card-body d-flex flex-column">
    <!-- Header -->
    <!--<div class="d-flex align-items-center mb-2">
        <span class="d-flex align-items-center justify-content-center bg-light-orange rounded me-3">
          <i class="ti ti-arrow-big-up-line-filled" style="font-size: 1.5rem; color: #ff5722"></i>
        </span>
        <h4 class="fw-bold mb-0">{{ plan.name }}</h4>
      </div>-->
    <div class="price pt-4">
      <div class="d-flex align-items-center mb-2">
        <span class="d-flex align-items-center flex-wrap price-icon me-3"
          ><i
            class="ti ti-arrow-big-up-line-filled fs-20 p-3 rounded-3"
            style="font-size: 1.5rem; background-color: #ff5722; color: white"
          ></i
        ></span>
        <p class="fs-20 d-flex align-items-center">{{ plan.name }}</p>
      </div>
      <div class="d-flex pt-2 mt-4 border-top">
        <div class="d-flex flex-column">
          <!--Show original price with a strikethrough -->
          <div *ngIf="plan.hasDiscount">
            <h5
              class="fs-24 text-gray-5 text-decoration-line-through d-flex align-items-center me-2"
            >
              <span *ngIf="plan.planCurrency?.currency_symbol">{{
                plan.planCurrency?.currency_symbol
              }}</span
              >{{ plan.originalPrice ?? '0.00' }}
            </h5>
          </div>
          <!--{{! Show the final price (discounted or original) }}-->
          <div>
            <span class="fs-1 text-dark fw-bold">
              {{ plan.planCurrency?.currency_symbol ?? '$' }}{{ plan.price }}
            </span>
            <span class="text-gray-5 fs-14">{{ plan.billingCycleText }}</span>
          </div>
        </div>
        <!--{{! DYNAMIC: Use the billingCycleText from our controller }}-->
      </div>
    </div>
    <div class="mt-3 flex-grow-1">
      <ul *ngFor="let feature of plan.featuresList">
        <li *ngIf="feature.isFeature; else elseBlock" class="d-flex align-items-center mb-2">
          <i class="ti {{ feature.icon }} fw-semi-bold me-2 {{ feature.colorClass }} fs-16"></i>
          {{ feature.text }}
        </li>
        <ng-template #elseBlock>
          <li class="d-flex align-items-center fs-14 text-gray-5 mb-2">
            {{ feature.text }}
          </li>
        </ng-template>
      </ul>
      <div *ngIf="plan.hasMoreFeatures" class="more-features-container d-flex justify-content-end">
        <a href="javascript:void(0);" class="more-features-link"
          >and
          {{ plan.hiddenFeaturesList.length }}
          more...</a
        >
        <div *ngIf="plan.hasMoreFeatures" class="more-features-tooltip">
          <ul>
            <ng-container *ngFor="let feature of plan.hiddenFeaturesList">
              <li
                *ngIf="feature.isFeature; else plainTextBlock"
                class="d-flex align-items-center fs-14 text-gray-5 mb-2"
              >
                <i
                  class="ti {{ feature.icon }} fw-semi-bold me-2 {{ feature.colorClass }} fs-16"
                ></i>
                {{ feature.text }}
              </li>
              <ng-template #plainTextBlock>
                <li class="d-flex align-items-center fs-14 text-gray-5 mb-2">
                  {{ feature.text }}
                </li>
              </ng-template>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
    <!-- Action Button -->
    <div class="d-grid gap-2 mb-4">
      <!-- <button
        *ngIf="!isCurrentPlan || currentPlan?.subscriptionStatus === SubscriptionStatus.Trialing"
        (click)="onGetStarted()"
        class="btn btn-square btn-outline-primary"
      >
        Get Started
      </button> -->
      <!-- <button
        *ngIf="showGetStarted()"
        (click)="onGetStarted()"
        class="btn btn-square btn-outline-primary"
      >
        Get Started
      </button> -->
      <button (click)="onGetStarted()" class="btn btn-square btn-outline-primary">
        Get Started
      </button>
    </div>
  </div>
</div>
